// extracted by mini-css-extract-plugin
export default {"desktop":"desktop","shlyapa":"wG56y_Mp"};